import script from "./Common-resource-list.vue?vue&type=script&setup=true&lang=js"
export * from "./Common-resource-list.vue?vue&type=script&setup=true&lang=js"

import "./Common-resource-list.vue?vue&type=style&index=0&id=0f346c22&lang=scss&scoped=true"
import "./Common-resource-list.vue?vue&type=style&index=1&id=0f346c22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f346c22"]])

export default __exports__